module.exports = __webpack_public_path__ + "img/layer2.f244b959.png";